module.exports = __webpack_public_path__ + "img/pista.d645b961.jpg";